import React, { Component } from "react"
import Work from "./work"
import Navigation from "./nav"
import Blog from "./blog"
import Post from "./blog/post"
import Tag from "./blog/tag"
import Dev from "./blog/dev"
import Home from "./home"
import { BlogProvider } from "./blog/blogContext"
import { parseUrl } from '../utils'

import styled from 'styled-components'
import { createGlobalStyle } from 'styled-components'

import palette from './palette'

const GlobalStyle = createGlobalStyle`
  body {
    background-color: ${palette.background};
  }
  .main-site {
    width: 560px;
    margin: auto;
  }
`;

const Main = styled.div`
  @import url('https://fonts.googleapis.com/css?family=Roboto&display=swap');

  font-family: sans-serif;
  color: ${palette.text};

  h1 {
    font-family: 'Roboto', sans-serif;
    color: ${palette.heading};
    margin-top: 50px;
  }

  h2, h3 {
    margin-top: 50px;
  }

  ul {
    list-style: none;
    padding: 0;
  }

  a {
    text-decoration: none;
    color: ${palette.text};
  }

  #post-body a {
    &:link {
      color: ${palette.link};
    }
    &:visited {
      color: ${palette.visitedLink};
    }
    &:hover {
      color: ${palette.link};
    }
  }

  code {
    background-color: rgba(31, 122, 140, 0.2);
    border: 1px solid ${palette.imageBorder};
    border-radius: 3px;
    padding: 2px 6px;
    font-family: 'Courier New', monospace;
    font-size: .8em;
  }

  pre {
    background-color: rgba(31, 122, 140, 0.15);
    border: 1px solid ${palette.imageBorder};
    border-radius: 5px;
    padding: 15px;
    overflow-x: auto;
    margin: 20px 0;

    code {
      background-color: transparent;
      border: none;
      padding: 0;
      border-radius: 0;
    }
  }

  .loading {
    margin-top: 50px;
  }
`

class MainContainer extends Component {

  render() {
    let res = []
    const {parts, searchParams} = parseUrl()
    const section = parts.length > 0 ? parts[0] : ''
    const tagOrPostId = parts[1]

    let middle = null
    switch(section) {
      case 'work':
        middle = <Work key="work"/>
        break
      case 'post':
        middle = <Post key="post" id={tagOrPostId} />
        break
      case 'blog':
        middle = <Blog key="blog" searchParams={searchParams} />
        break
      case 'dev':
        middle = <Dev key="dev" searchParams={searchParams} />
        break
      case 'tags':
        middle = <Tag key="tag" id={tagOrPostId} searchParams={searchParams} />
        break
      default:
        middle = <Home key="home" />
    }
    res.push(middle)

    return (

      <BlogProvider>
        <GlobalStyle />
        <Main>
          <Navigation key="nav" section={section} />
          <div class="main-site">{res}</div>
        </Main>
      </BlogProvider>
    )
  }

}
export default MainContainer